export default __webpack_public_path__ + "static/media/cart.fb034dff.svg";